import React, { Component } from 'react'
import { Pane, Heading, Table, Badge, Text, Link, Spinner, Alert, Button } from 'evergreen-ui';
import moment from 'moment';
import Api from '../../../util/Api';

class LatestReviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reviews: [],
      loading: true,
      error: null
    };
  }

  componentDidMount() {
    this.fetchLatestReviews();
  }

  fetchLatestReviews = async () => {
    try {
      this.setState({ loading: true, error: null });
      const response = await Api.get('/dashboard/latest-reviews');

      if (response.success) {
        this.setState({ reviews: response.reviews, loading: false });
      } else {
        this.setState({ error: 'Failed to fetch reviews', loading: false });
      }
    } catch (error) {
      console.error('Error fetching latest reviews:', error);
      this.setState({
        error: 'Failed to load reviews',
        loading: false
      });
    }
  };

  renderStars(rating) {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span key={i} style={{ color: i <= rating ? '#FFD700' : '#ddd', fontSize: '18px' }}>
          ★
        </span>
      );
    }
    return stars;
  }

  render() {
    const { reviews, loading, error } = this.state;

    return (
      <Pane>
        <Pane display="flex" alignItems="center" justifyContent="space-between" marginBottom={16}>
          <Heading size={600}>
            Latest Order Reviews
          </Heading>
          <Link href="/orders/reviews">
            <Button appearance="primary" size="small">
              View All Reviews
            </Button>
          </Link>
        </Pane>

        {loading ? (
          <Pane display="flex" alignItems="center" justifyContent="center" padding={40}>
            <Spinner />
          </Pane>
        ) : error ? (
          <Pane padding={16}>
            <Alert intent="danger" title="Error loading reviews">
              {error}
            </Alert>
          </Pane>
        ) : !reviews || reviews.length === 0 ? (
          <Pane padding={16}>
            <Alert intent="none" title="No reviews yet">
              There are no order reviews to display.
            </Alert>
          </Pane>
        ) : (
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Order #</Table.TextHeaderCell>
            <Table.TextHeaderCell>Rating</Table.TextHeaderCell>
            <Table.TextHeaderCell>Comment</Table.TextHeaderCell>
            <Table.TextHeaderCell>Date</Table.TextHeaderCell>
            <Table.TextHeaderCell>Actions</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            {reviews.map((review) => (
              <Table.Row key={review.id}>
                <Table.TextCell>
                  <Link href={`/orders/${review.orderId}`} target="_blank" rel="noopener noreferrer">
                    #{review.orderNumber}
                  </Link>
                </Table.TextCell>
                <Table.TextCell>
                  <Pane display="flex" alignItems="center">
                    {this.renderStars(review.rating)}
                    <Text marginLeft={8} size={400} color="muted">
                      ({review.rating}/5)
                    </Text>
                  </Pane>
                </Table.TextCell>
                <Table.TextCell>
                  {review.comment ? (
                    <Text
                      size={400}
                      style={{
                        maxWidth: '300px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block'
                      }}
                      title={review.comment}
                    >
                      {review.comment}
                    </Text>
                  ) : (
                    <Text size={400} color="muted">
                      No comment
                    </Text>
                  )}
                </Table.TextCell>
                <Table.TextCell>
                  <Text size={400}>
                    {moment(review.createdAt).format('DD/MM/YYYY HH:mm')}
                  </Text>
                </Table.TextCell>
                <Table.TextCell>
                  <Link href={`/orders/${review.orderId}`} target="_blank" rel="noopener noreferrer">
                    View Order
                  </Link>
                </Table.TextCell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
        )}
      </Pane>
    );
  }
}

export default LatestReviews;
